/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Equipment_Place_LongInputs */

const en_us2_intake_why_equipment_place_long = /** @type {(inputs: Intake_Why_Equipment_Place_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every exercise needs something. We never suggest gear you do not have.`)
};

const pt_br2_intake_why_equipment_place_long = /** @type {(inputs: Intake_Why_Equipment_Place_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo exercício precisa de algo. Nunca sugerimos equipamento que você não tem.`)
};

const es_419_intake_why_equipment_place_long = /** @type {(inputs: Intake_Why_Equipment_Place_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo ejercicio necesita algo. Nunca sugerimos equipo que no tienes.`)
};

const pt_pt2_intake_why_equipment_place_long = /** @type {(inputs: Intake_Why_Equipment_Place_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os exercícios precisam de algo. Nunca sugerimos equipamento que não tens.`)
};

const fr_fr2_intake_why_equipment_place_long = /** @type {(inputs: Intake_Why_Equipment_Place_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque exercice demande du matériel. On ne te propose jamais du matériel que tu n'as pas.`)
};

const de_de2_intake_why_equipment_place_long = /** @type {(inputs: Intake_Why_Equipment_Place_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Übung braucht etwas. Wir schlagen nie Ausrüstung vor, die du nicht hast.`)
};

const it_it2_intake_why_equipment_place_long = /** @type {(inputs: Intake_Why_Equipment_Place_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni esercizio richiede qualcosa. Non suggeriamo mai attrezzi che non hai.`)
};

/**
* | output |
* | --- |
* | "Every exercise needs something. We never suggest gear you do not have." |
*
* @param {Intake_Why_Equipment_Place_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_equipment_place_long = /** @type {((inputs?: Intake_Why_Equipment_Place_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Equipment_Place_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_equipment_place_long(inputs)
	if (locale === "es-419") return es_419_intake_why_equipment_place_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_equipment_place_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_equipment_place_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_equipment_place_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_equipment_place_long(inputs)
	return en_us2_intake_why_equipment_place_long(inputs)
});
export { intake_why_equipment_place_long as "intake.why.equipment_place.long" }